import { render } from "./Innovation.vue?vue&type=template&id=17eb45bd&scoped=true"
import script from "./Innovation.vue?vue&type=script&lang=js"
export * from "./Innovation.vue?vue&type=script&lang=js"

import "./Innovation.vue?vue&type=style&index=0&id=17eb45bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17eb45bd"]])

export default __exports__